module.exports = __webpack_public_path__ + "media/images/checkout/diners-d384cb88d6524f8d0a2ca831e258f456.png";